module.exports = "/_next/static/images/3b71114efb4796f3def3f1858f89de64-hands-holding-cards-md@2x.jpg.webp";